import { usePosts } from '../hooks/usePosts';
import PostCard from '../components/PostCard';
import { Plus } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuthContext } from '../../../components/AuthProvider';

export default function BlogList() {
  const { data: posts, isLoading } = usePosts();
  const { isAuthenticated } = useAuthContext();

  if (isLoading) {
    return <div className="text-center py-8">加载中...</div>;
  }

  return (
    <div className="max-w-4xl mx-auto">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">博客文章</h1>
        {isAuthenticated && (
          <Link
            to="/blog/new"
            className="inline-flex items-center px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
          >
            <Plus className="w-4 h-4 mr-2" />
            写文章
          </Link>
        )}
      </div>

      <div className="grid gap-6">
        {posts?.map((post) => (
          <PostCard key={post.id} post={post} />
        ))}
        {posts?.length === 0 && (
          <div className="text-center py-8 text-gray-500">
            暂无文章
          </div>
        )}
      </div>
    </div>
  );
}